import StripePayment from '../../payment/StripePayment';
import type {UnifiedOnboardingData} from '../../../lib/onboarding/unifiedTypes';

interface WelcomePaymentStepProps {
  data: UnifiedOnboardingData;
  onUpdate: (updates: Partial<UnifiedOnboardingData>) => void;
  onNext: () => void;
}

export default function WelcomePaymentStep({data, onUpdate, onNext}: WelcomePaymentStepProps) {
  const handlePaymentComplete = ({paymentMethodId, customerId, priceId}: {
    paymentMethodId: string,
    customerId: string,
    priceId: string
  }) => {
    onUpdate({
      paymentCompleted: true,
      paymentMethodId,
      customerId,
      priceId
    });
    onNext();
  };

  return (
    <StripePayment
      email={data.email}
      onPaymentComplete={handlePaymentComplete}
    />
  );
}
